import React from 'react';
import { Box, Container, Grid, Typography } from '@material-ui/core';

const StatisticsMetricsShowcase = ({ sectionConfig = {}, layoutContext = {} }) => {
    const { getAnimationProps } = layoutContext;
    const items = sectionConfig.items || [];

    if (!items.length) {
        return null;
    }

    const applyAnimation = (animationConfig, index = 0) => (
        typeof getAnimationProps === 'function' ? getAnimationProps(animationConfig, index) : {}
    );
    const sectionAnimation = applyAnimation(sectionConfig.animation?.section);
    const titleAnimation = applyAnimation(sectionConfig.animation?.title);

    return (
        <Box
            id="statistics-section"
            className={sectionAnimation.className}
            data-anim={sectionAnimation.dataAnim}
            data-delay={sectionAnimation.dataDelay}
            data-trigger-once={sectionAnimation.dataTriggerOnce}
            style={{ ...(sectionConfig.styles || {}), ...(sectionAnimation.style || {}) }}
        >
            <Container maxWidth={sectionConfig.container?.maxWidth || 'lg'} style={sectionConfig.containerStyles || {}}>
                <Box
                    className={titleAnimation.className}
                    data-anim={titleAnimation.dataAnim}
                    data-delay={titleAnimation.dataDelay}
                    data-trigger-once={titleAnimation.dataTriggerOnce}
                    style={{ ...(sectionConfig.titleContainerStyles || {}), ...(titleAnimation.style || {}) }}
                >
                    {sectionConfig.label && (
                        <Typography variant={sectionConfig.typography?.label?.variant || 'body2'} style={sectionConfig.labelStyles || {}}>
                            {sectionConfig.label}
                        </Typography>
                    )}
                    <Typography variant={sectionConfig.typography?.title?.variant || 'h3'} style={sectionConfig.titleStyles || {}}>
                        {sectionConfig.title}
                    </Typography>
                    {sectionConfig.subtitle && (
                        <Typography variant={sectionConfig.typography?.subtitle?.variant || 'body1'} style={sectionConfig.subtitleStyles || {}}>
                            {sectionConfig.subtitle}
                        </Typography>
                    )}
                </Box>
                <Grid container spacing={sectionConfig.contentGrid?.spacing || 4} alignItems="stretch">
                    <Grid item xs={sectionConfig.metricsGridItem?.xs || 12} lg={sectionConfig.metricsGridItem?.lg || 7}>
                        <Box style={sectionConfig.metricGridStyles || {}}>
                            {items.map((stat, index) => {
                                const metricAnimation = applyAnimation(sectionConfig.animation?.items, index);
                                return (
                                    <Box
                                        key={`stat-${index}`}
                                        className={metricAnimation.className}
                                        data-anim={metricAnimation.dataAnim}
                                        data-delay={metricAnimation.dataDelay}
                                        data-trigger-once={metricAnimation.dataTriggerOnce}
                                        style={{
                                            ...(sectionConfig.metricCardStyles || {}),
                                            borderLeftColor: stat.borderColor || stat.color || sectionConfig.metricCardStyles?.borderLeftColor,
                                            boxShadow: stat.shadow || sectionConfig.metricCardStyles?.boxShadow,
                                            ...(metricAnimation.style || {})
                                        }}
                                    >
                                        <Typography
                                            variant={sectionConfig.typography?.value?.variant || 'h2'}
                                            style={{
                                                ...(sectionConfig.metricValueStyles || {}),
                                                color: stat.color || sectionConfig.metricValueStyles?.color
                                            }}
                                        >
                                            {stat.value}
                                        </Typography>
                                        <Typography variant={sectionConfig.typography?.label?.variant || 'subtitle2'} style={sectionConfig.metricLabelStyles || {}}>
                                            {stat.label}
                                        </Typography>
                                        {stat.description && (
                                            <Typography
                                                variant={sectionConfig.typography?.description?.variant || 'body2'}
                                                style={sectionConfig.metricDescriptionStyles || {}}
                                            >
                                                {stat.description}
                                            </Typography>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Grid>
                    {sectionConfig.testimonial && (() => {
                        const testimonialAnimation = applyAnimation(sectionConfig.animation?.testimonial);
                        return (
                            <Grid item xs={sectionConfig.testimonialGridItem?.xs || 12} lg={sectionConfig.testimonialGridItem?.lg || 5}>
                                <Box
                                    className={testimonialAnimation.className}
                                    data-anim={testimonialAnimation.dataAnim}
                                    data-delay={testimonialAnimation.dataDelay}
                                    data-trigger-once={testimonialAnimation.dataTriggerOnce}
                                    style={{ ...(sectionConfig.testimonial?.styles || {}), ...(testimonialAnimation.style || {}) }}
                                >
                                    <Typography variant={sectionConfig.testimonial?.typography?.quote?.variant || 'h5'} style={sectionConfig.testimonial?.quoteStyles || {}}>
                                        {sectionConfig.testimonial.quote}
                                    </Typography>
                                    <Typography variant={sectionConfig.testimonial?.typography?.author?.variant || 'subtitle1'} style={sectionConfig.testimonial?.authorStyles || {}}>
                                        {sectionConfig.testimonial.author}
                                    </Typography>
                                    <Typography variant={sectionConfig.testimonial?.typography?.title?.variant || 'body2'} style={sectionConfig.testimonial?.titleStyles || {}}>
                                        {sectionConfig.testimonial.title}
                                    </Typography>
                                </Box>
                            </Grid>
                        );
                    })()}
                </Grid>
            </Container>
        </Box>
    );
};

export default StatisticsMetricsShowcase;
